<template>
  <div id="comp-notice-item" @click="goNoticeDetail">
    <span id="noti-num" :class="{ hide: noticeType != 'notify' }">{{
      num
    }}</span>
    <span id="noti-content">
      <span id="noti-title">{{ title }}</span>
      <br />
      <span id="noti-date">{{ getDateText }}</span>
      <div id="noti-confirm" :class="{ hide: noticeType != 'invite' }">
        <div class="btn" @click="$emit('disagree', alarmId)">
          거절
        </div>
        <div
          class="btn active"
          @click="$emit('agree', groupId, alarmId, userSeqId)"
        >
          수락
        </div>
      </div>
    </span>
    <i
      class="fas fa-chevron-right"
      :class="{ hide: noticeType != 'notify' }"
    ></i>
    <hr id="noti-divider" />
  </div>
</template>

<script>
import common from '@/utils/common';

export default {
  name: 'CompNoticeItem',
  mixins: [common],
  props: {
    num: Number,
    title: String,
    userSeqId: Number,
    alarmId: Number,
    groupId: Number,
    dateTime: Number,
    noticeType: String,
  },
  data() {
    return {};
  },
  computed: {
    getDateText() {
      const noticeDate = new Date(this.dateTime);

      const year = noticeDate.getFullYear();
      let month = (noticeDate.getMonth() + 1).toString();
      let day = noticeDate.getDate().toString();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join('-');
    },
  },
  methods: {
    goNoticeDetail() {
      this.$emit('noticeDetail');
    },
  },
};
</script>

<style lang="scss" src="../scss/comp-notice-item.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/CompNoticeItem.vue